import React from "react";

function ChartsHeader(props) {
  return <div></div>;
}

export default ChartsHeader;
